import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { FeatureDeprecated, RoomProperties } from '@vi-iot/client';

import { InstallationService } from '../../../services/installation.service';

@Component({
  selector: 'app-src-manager-modal',
  templateUrl: './src-manager-modal.component.html',
  styleUrls: ['./src-manager-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SrcManagerModalComponent {
  room: FeatureDeprecated<RoomProperties>;
  manager: string;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { manager: string; room: FeatureDeprecated<RoomProperties> },
    public dialogRef: MatDialogRef<SrcManagerModalComponent>,
    public installationService: InstallationService
  ) {
    this.manager = data.manager;
    this.room = data.room;
  }

  close(): void {
    this.dialogRef.close();
  }
}
